import { render, staticRenderFns } from "./TeacherOlympiadWinners.vue?vue&type=template&id=079042bc&scoped=true"
import script from "./TeacherOlympiadWinners.vue?vue&type=script&lang=js"
export * from "./TeacherOlympiadWinners.vue?vue&type=script&lang=js"
import style0 from "./TeacherOlympiadWinners.vue?vue&type=style&index=0&id=079042bc&prod&lang=css&scoped=true"
import style1 from "./TeacherOlympiadWinners.vue?vue&type=style&index=1&id=079042bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079042bc",
  null
  
)

export default component.exports